import { render, staticRenderFns } from "./UitzendBevestiging.vue?vue&type=template&id=00c8d646&"
import script from "./UitzendBevestiging.vue?vue&type=script&lang=ts&"
export * from "./UitzendBevestiging.vue?vue&type=script&lang=ts&"
import style0 from "./UitzendBevestiging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports